@if (slideAuthorFacade.currentSelectedSlideQuestion$ | async; as question) {
  <!-- Header -->
  <medsurf-slide-edit-header [icon]="FlatModels.QuestionEntityModels.QuestionTypeIcon[question.type]"
    [label]="question.content | stripTags"
    [type]="'enum.question.' + question.type"></medsurf-slide-edit-header>
  <!-- Content -->
  <div #edit_overlay_template_scroll_panel
    class="flex flex-1 overflow-auto justify-content-center">
    <!-- Question Form -->
    @if (questionForm) {
      <medsurf-design-form-control-form
        [formGroup]="questionForm"
        class="w-full h-full ml-3 mr-3"
        (onSubmit)="onSubmit()">
        <div class="flex flex-column align-items-center">
          <!-- Question Type -->
          <medsurf-design-form-control-input-dropdown [control]="questionForm.controls.type"
            label="global.question_type"
            [options]="FlatModels.QuestionEntityModels.QuestionTypeArray"
            class="w-full"
          (valueChange)="onQuestionTypeSubmit()"></medsurf-design-form-control-input-dropdown>
          <!-- Custom Enumeration -->
          <medsurf-design-form-control-input-text [control]="questionForm.controls.customEnumeration"
                                                  label="global.custom_enumeration"
                                                  placeholder="global.custom_enumeration"
                                                  class="w-full"
                                                  (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
          <!-- Required -->
          <medsurf-design-form-control-input-checkbox [control]="questionForm.controls.required"
            label="global.question_required"
            class="w-full"
          (valueChange)="onSubmit()"></medsurf-design-form-control-input-checkbox>
          <!-- Randomised -->
          @if (FlatModels.QuestionEntityModels.ShowRandomized.includes(question.type)) {
            <medsurf-design-form-control-input-checkbox
              [control]="questionForm.controls.randomised"
              label="global.question_randomised"
              class="w-full"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-checkbox>
          }
          <!-- Numbering Type -->
          @if (FlatModels.QuestionEntityModels.ShowNumberingType.includes(question.type)) {
            <medsurf-design-form-control-input-dropdown
              [control]="questionForm.controls.numberingType"
              label="global.numbering_type"
              [options]="FlatModels.QuestionEntityModels.NumberingTypeArray"
              class="w-full"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-dropdown>
          }
        </div>
      </medsurf-design-form-control-form>
    }
  </div>
}
